:host {
    border: 1px solid #c8cccf;
    display: flex;
    flex-direction: column;
}

.image-wrapper {
    position: relative;

    slot {
        display: block;
        overflow: hidden;
        cursor: pointer;
    }
}

:host(.no-button) {
    .image-wrapper {
        slot {
            cursor: unset;
            pointer-events: none;
        }
    }
}

.video {
    @include video-play-button;
}

::slotted(sew-picture) {
    aspect-ratio: 2 / 1;
    transition: transform 0.2s ease;
}

::slotted(sew-picture:hover) {
    transform: scale(1.2);
}

.headline,
.text,
slot[name='button'] {
    margin: 0 32px;
}

.headline {
    @include typo-ws-h3;

    margin-top: 24px;
}

.text {
    @include typo-ws-paragraph;

    // hier wurde mit Absicht auf die scss Funktion verzichtet.
    margin-top: clamp(14px, 0.972vw, 18.666px);
    margin-bottom: 32px;
}

slot[name='button'] {
    display: block;
    margin-bottom: 40px;
    margin-top: auto;
}

@include mq-1 {
    .headline,
    .text,
    slot[name='button'] {
        margin-left: 20px;
        margin-right: 20px;
    }
}
